const Events = {
  registered: {},
  scrollEvent: {
    register: (evtName: any, callback: any) => {
      Events.registered[evtName] = callback;
    },
    remove: (evtName: any) => {
      Events.registered[evtName] = null;
    },
  },
};

export default Events;
